import { Config } from '@interfaces/mainInterfaces';
import * as actionTypes from './actionTypes';

export const saveConfig = (config: Config) => {
    return {
        type: actionTypes.SAVE_CONFIG,
        config,
    };
};

export const setIsMobile = (isMobile: boolean) => {
    return {
        type: actionTypes.SET_IS_MOBILE,
        isMobile,
    };
};

export const setIsLoggedIn = (isLoggedIn: boolean) => {
    return {
        type: actionTypes.SET_IS_LOGGED_IN,
        isLoggedIn: isLoggedIn ? 'LOGGED' : 'NOT_LOGGED',
    };
};
